<script setup>
import { useSessionData } from '@/core/composables/useSessionData'
import teamupLogo from '@/core/assets/logo_dark.svg'
import poweredByTeamUp from '@/core/assets/powered_by_teamup.svg'

const { isHomePage } = useIsHomePage()
const { currentProviderLogoUrl, currentProviderName, currentProviderSlug } = useSessionData()
const { features: { hide_powered_by_teamup: hidePoweredByTeamUp } } = useFeatures()
</script>

<template>
  <div class="app-logo flex shrink-0 items-center justify-start flex-gap-x-1 lt-sm:!hidden">
    <img
      v-if="isHomePage"
      :src="teamupLogo"
      alt="TeamUp Logo"
      class="h-34px"
    >
    <template v-else>
      <a
        v-if="currentProviderLogoUrl"
        :href="`/p/${currentProviderSlug}`"
      >
        <BaseImage
          :src="currentProviderLogoUrl"
          class="w-auto lt-md:h-34px md:h-60px"
        />
      </a>
      <span
        v-else
        class="h4"
      >{{ currentProviderName }}</span>
      <!-- <AppPoweredByTeamUp /> -->
      <img
        v-if="!hidePoweredByTeamUp"
        :src="poweredByTeamUp"
      >
    </template>
  </div>
</template>
